<template>
  <div class='appointBox' style='width: calc(95% - 200px);'>
    <div class='eq_header'>
      <div
        style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
        考核信息</div>
      <span style='font-size:14px;color:#999999'>您的位置：个人中心><span
          style="color:#188335">考核信息</span></span>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="考核记录" name="first">
        <assessmentRecord></assessmentRecord>
      </el-tab-pane>
      <el-tab-pane label="试卷信息" name="second">
        <testInformation></testInformation>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import assessmentRecord from './dialog/assessmentRecord.vue'
import testInformation from './dialog/testInformation.vue'
export default {
  props: {
  },
  components: {
    testInformation, assessmentRecord
  },
  data() {
    return {
      activeName: 'first',
    }
  },
  methods: {
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      }
      this.dateRange = []
      this.init()
    },
    handleTime(date) {
      if (date) {
        this.formData.createTimeStart = date[0]
        this.formData.createTimeEnd = date[1]
      } else {
        this.formData.createTimeStart = []
        this.formData.createTimeEnd = []
      }
    },
    handleTimeuse(date) {
      if (date) {
        this.formData.usageTimeStart = date[0]
        this.formData.usageTimeEnd = date[1]
      } else {
        this.formData.usageTimeStart = []
        this.formData.usageTimeEnd = []
      }
    },
    Nindex(index) {
      const page = this.formData.pageNum
      const pagesize = this.formData.pageSize
      return index + 1 + (page - 1) * pagesize
    },

    init() {

    },


  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.appointBox {
  .eq_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
}
</style>